import { useState, useRef, useEffect, createElement } from 'react';
import MuiSlider from '@material-ui/core/Slider';
import { useTheme, useClassNames, Tooltip } from '@framework-controls/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Slider-module_slider_colorDefault__24-my {\n  background-color: var(--defaultColor);\n}\n.Slider-module_slider_colorContrast__2PYM1 {\n  background-color: var(--contrastColor);\n}\n.Slider-module_slider_colorPrimary__326BT {\n  background-color: var(--primaryColor);\n}\n.Slider-module_slider_colorSecondary__28WHY {\n  background-color: var(--secondaryColor);\n}\n.Slider-module_slider_colorError__3pACj {\n  background-color: var(--errorColor);\n}\n.Slider-module_slider_colorLabel__1rSIu {\n  background-color: var(--labelColor);\n}\n.Slider-module_slider_colorCompleted__1qh7M {\n  background-color: var(--completeColor);\n}\n.Slider-module_slider_colorTransparent__2l5nD {\n  background-color: transparent;\n}\n.Slider-module_slider_sizeXs__1X6pE {\n  width: 15rem !important;\n}\n.Slider-module_slider_sizeSm__2psBa {\n  width: 25rem !important;\n}\n.Slider-module_slider_sizeMd__GO0rC {\n  width: 35rem !important;\n}\n.Slider-module_slider_sizeLg__2HKC6 {\n  width: 45rem !important;\n}\n.Slider-module_slider_size15x__xGMyn {\n  width: 55rem !important;\n}\n.Slider-module_slider_sizeXl__oiSF8 {\n  width: 65rem !important;\n}\n.Slider-module_slider_sizeXxl__2W1ZN {\n  width: 75rem !important;\n}\n.Slider-module_slider_size3xl__1cEYA {\n  width: 85rem !important;\n}\n.Slider-module_slider_sizeStatic__25o_h {\n  width: 250px !important;\n}\n.Slider-module_slider_sizeStaticsm__1hksq {\n  width: 150px !important;\n}\n.Slider-module_slider_sizeStaticlg__3tFd7 {\n  width: 450px !important;\n}\n.Slider-module_slider_sizeStaticxl__35Fg6 {\n  width: 650px !important;\n}";
var css = {"slider_colorDefault":"Slider-module_slider_colorDefault__24-my","slider_colorContrast":"Slider-module_slider_colorContrast__2PYM1","slider_colorPrimary":"Slider-module_slider_colorPrimary__326BT","slider_colorSecondary":"Slider-module_slider_colorSecondary__28WHY","slider_colorError":"Slider-module_slider_colorError__3pACj","slider_colorLabel":"Slider-module_slider_colorLabel__1rSIu","slider_colorCompleted":"Slider-module_slider_colorCompleted__1qh7M","slider_colorTransparent":"Slider-module_slider_colorTransparent__2l5nD","slider_sizeXs":"Slider-module_slider_sizeXs__1X6pE","slider_sizeSm":"Slider-module_slider_sizeSm__2psBa","slider_sizeMd":"Slider-module_slider_sizeMd__GO0rC","slider_sizeLg":"Slider-module_slider_sizeLg__2HKC6","slider_size15x":"Slider-module_slider_size15x__xGMyn","slider_sizeXl":"Slider-module_slider_sizeXl__oiSF8","slider_sizeXxl":"Slider-module_slider_sizeXxl__2W1ZN","slider_size3xl":"Slider-module_slider_size3xl__1cEYA","slider_sizeStatic":"Slider-module_slider_sizeStatic__25o_h","slider_sizeStaticsm":"Slider-module_slider_sizeStaticsm__1hksq","slider_sizeStaticlg":"Slider-module_slider_sizeStaticlg__3tFd7","slider_sizeStaticxl":"Slider-module_slider_sizeStaticxl__35Fg6"};
styleInject(css_248z,{"insertAt":"top"});

const useSliderTheme = makeStyles((theme) => createStyles({
    // root: {
    //     color: props => props.color,
    //     height: props => `${props.height}px`,
    // },
    thumb: {
        height: 24,
        width: 24,
        border: '2px solid currentColor',
        marginTop: '-8px !important',
        marginLeft: '-12px !important',
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {
        boxShadow: '0px 0px 0px 14px ',
    },
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
    mark: {
        height: 8,
        width: 1,
    },
}));
const Slider = (props) => {
    var _a, _b, _c;
    const width = (_a = props.width) !== null && _a !== void 0 ? _a : 'Md';
    // const height = (props.height && props.height > 10) ? props.height : 10;
    const backColor = (_b = props.backgroundColor) !== null && _b !== void 0 ? _b : 'transparent';
    // const color = (props.color !== undefined) ? `var(--${props.color}Color) !important` : `var(--defaultColor) !important`;
    const disabled = (props.disabled !== undefined) ? props.disabled : false;
    const value = (_c = props.value) !== null && _c !== void 0 ? _c : 0;
    const minValue = (props.min !== undefined) ? props.min : 0;
    const maxValue = (props.max !== undefined) ? props.max : 100;
    const step = (props.step !== undefined) ? props.step : 1;
    const [sliderVal, setSliderVal] = useState(value);
    const sliderRef = useRef();
    // const markStyles = props.markStyles!;
    // const railStyles = props.railStyles!;
    // const thumbStyles = props.thumbStyles!;
    // const trackStyles = props.trackStyles!;
    const theme = useTheme(css);
    const sliderClassName = useClassNames(theme, 'slider', [`size${width.charAt(0).toUpperCase() + width.slice(1)}`,
        `color${backColor.charAt(0).toUpperCase() + backColor.slice(1)}`,
    ]);
    /** Create Tooltip label with Slider value */
    function ValueLabelComponent(props) {
        const { children, open, value } = props;
        return (createElement(Tooltip, { open: open, placement: 'top-start', text: value.toString() }, children));
    }
    /** Execute onChange only for last value after slider stops moving (wait for .25 seconds) */
    useEffect(() => {
        /** If number of steps is less than 20, don't wait to change (looks weird) */
        let timerCount = 250;
        if ((maxValue - minValue) / step <= 20) {
            timerCount = 0;
        }
        const timer = setTimeout(() => {
            const thumbChildren = Array.prototype.slice.call(sliderRef.current.children).filter(function (child) {
                return child.classList.contains('MuiSlider-thumb');
            });
            let isNewValue = false;
            if (typeof sliderVal === 'number') {
                if (sliderVal !== +(thumbChildren[0]).getAttribute('aria-valuenow') &&
                    props.onChange !== undefined) {
                    isNewValue = true;
                }
            }
            else {
                sliderVal.forEach((value, index) => {
                    if (value !== +(thumbChildren[index]).getAttribute('aria-valuenow')) {
                        isNewValue = true;
                    }
                });
            }
            if (isNewValue && props.onChange !== undefined) {
                props.onChange(props.id, sliderVal);
            }
        }, timerCount);
        return () => {
            clearTimeout(timer);
        };
    }, [maxValue, minValue, step, sliderRef, sliderVal, props === null || props === void 0 ? void 0 : props.onChange, props === null || props === void 0 ? void 0 : props.id]);
    function valueLabelFormat(value) {
        if (props.tooltipMarksDisplay !== undefined && Array.isArray(props.tooltipMarksDisplay)) {
            const mark = props.tooltipMarksDisplay.find(mark => mark.value === value);
            if (mark !== undefined) {
                return mark.label;
            }
        }
        return value;
    }
    const sliderTheme = useSliderTheme();
    const control = createElement(MuiSlider, { id: props.id, ref: sliderRef, classes: sliderTheme, className: sliderClassName, disabled: disabled, valueLabelDisplay: props.labelDisplay, min: minValue, max: maxValue, step: step, marks: props.marks, onChange: (e, val) => {
            setSliderVal(val);
        }, value: value, valueLabelFormat: valueLabelFormat, ValueLabelComponent: ValueLabelComponent });
    return control;
};

export { Slider };
